<div class="py-24 px-16">
  <h5 class="color-psr-text-color upper fw-bold f16 mt-18 mb-16">
    {{ 'login.insertCode.title' | translate }}
  </h5>
  <p *ngIf="!!verifyTwoFactor" class="f13 m-0 mb-34">
    {{ 'login.insertCode.description' | translate }}
    {{
      (isPhone === 'phone' ? 'labels.movil_phone' : 'labels.email') | translate
    }}
    {{ currentValue }}
  </p>
  <p *ngIf="!verifyTwoFactor" class="f13 m-0 mb-34">
    {{ 'login.insertCode.descriptionRecover' | translate }}
  </p>

  <form autocomplete="off">
    <app-pin
      idInput="insert-code"
      [classInputPin]="'w-100'"
      [codePresent]="codePresent"
      [code]="codeString"
      (validate)="validateField($event)">
    </app-pin>

    <ps-button
      buttonClass="mt-16"
      class="w-100"
      data-testid="btn-continue"
      height="tall"
      width="100%"
      [text]="((!!verifyTwoFactor ? 'actions.continue' : 'actions.verify') | translate)"
      (onClick)="verifyCode()">
    </ps-button>

    <div class="divider mt-24 mb-16"></div>

    <p class="color-psr-text-title-modal f13">
      {{ 'login.insertCode.question' | translate }}
    </p>

    <ps-button
      buttonClass="mt-16"
      class="w-100"
      color="secondary"
      data-testid="send-code"
      height="tall"
      width="100%"
      [disabled]="countValidation"
      [text]="countdown"
      (onClick)="sendCode()">
    </ps-button>
  </form>

  <div class="divider my-16"></div>

  <ps-button
    class="w-100"
    color="secondary"
    data-testid="btn-return"
    height="tall"
    width="100%"
    [text]="'actions.return' | translate"
    (onClick)="returnSelect()">
  </ps-button>
</div>
